import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Rocket = function Rocket(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M32.5 21C29.4625 21 27 18.5375 27 15.5C27 12.4625 29.4625 10 32.5 10C35.5375 10 38 12.4625 38 15.5C38 18.5375 35.5375 21 32.5 21ZM32.5 12C30.575 12 29 13.575 29 15.5C29 17.425 30.575 19 32.5 19C34.425 19 36 17.425 36 15.5C36 13.575 34.425 12 32.5 12Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.3126 35.1015L12.8984 33.6873L3.6973 42.8884L5.1115 44.3026L14.3126 35.1015Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.3097 31.1046L9.89551 29.6904L3.6907 35.8952L5.1049 37.3094L11.3097 31.1046Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.3097 38.1039L16.8955 36.6897L10.6907 42.8945L12.1049 44.3087L18.3097 38.1039Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M26 47.4128V34.3628H28V42.5878L35 35.5878V27.8253H37V36.4128L26 47.4128Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.6374 22H0.587402L11.5874 11H20.1624V13H12.4124L5.4124 20H13.6374V22Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.6372 37.05L10.9497 27.3625L11.0122 26.875C12.7872 12.7 27.3997 2 44.9997 2H45.9997V3C45.9997 20.575 35.3122 35.1875 21.1247 36.9875L20.6372 37.05ZM13.0622 26.6375L21.3622 34.9375C34.0372 33.0375 43.5997 19.925 43.9997 4.0125C28.0497 4.4 14.9497 13.9625 13.0622 26.6375Z",
      fill: color
    })]
  });
};
export default Rocket;